// The client page's :tab_id route param → the Nav's integer tab index. Accepts one of the tab
// indices the Nav renders or a string alias for the top-level surfaces; everything else — an
// index with no tab (13, 20), a fraction, an inherited object key such as "constructor" — falls
// back to Overview (0). Pure so the container can resolve it on mount AND whenever the param
// changes (Copilot on #201: /comms → /chats on a mounted Home left active_tab on the old tab).
export const TAB_ALIAS = { adoption: 14, findings: 15, actionables: 16, comms: 17, client_comms: 17, chats: 19, client_chats: 19 };

// Mirrors the NavLinks of StoreDashboard/index.jsx (there is no tab 13).
export const TAB_INDICES = new Set([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, 19]);

export function tab_index_of(raw) {
    if (typeof raw !== 'string') return 0;
    const key = raw.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(TAB_ALIAS, key)) return TAB_ALIAS[key];
    const numeric = /^\d+$/.test(raw) ? Number(raw) : NaN;
    return TAB_INDICES.has(numeric) ? numeric : 0;
}
